export default __webpack_public_path__ + "img/5-dimension-digital-twin.66ad0675.webp";